import { render, staticRenderFns } from "./FailedSms.vue?vue&type=template&id=48d3e510&scoped=true&"
import script from "./FailedSms.vue?vue&type=script&lang=js&"
export * from "./FailedSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3e510",
  null
  
)

export default component.exports